/**
 * Where each role's "home" lives.
 *
 * DISPLAY (the office TV kiosk) is wall-only: its single screen is the
 * Permit Wall at /wall, and it has no path back to the standard card-grid
 * dashboard. Every other role homes to /dashboard. Kept in one place so
 * the login redirect, the already-authed bounce, and the index/catch-all
 * routes can never disagree on where a role belongs.
 */

import type { Role } from "@/stores/authStore";

export function roleHome(role: Role | null | undefined): string {
  return role === "DISPLAY" ? "/wall" : "/dashboard";
}
